import * as React from 'react';
import { useContext, useEffect } from 'react';

import { withCookies, type ReactCookieProps } from 'react-cookie';
import { Helmet } from 'react-helmet-async';
import { makeStyles } from 'tss-react/mui';
import { ComplianzCookieConsent } from '../components/molecules';
import { Dashboard } from '../components/organisms';
import {
  AppConstantsContext,
  ExportTranscriptionProvider,
  NavigationContext,
  View,
} from '../context';
import { ProcessingProvider } from '../context/ProcessingContext/ProcessingContext';
import { AFFILIATE_CODE_ID } from '../services/AffiliateService';

const useStyles = makeStyles()((theme) => ({
  app: {
    height: 'calc(100% - 45px)',
    [theme.breakpoints.down('md')]: {
      height: '100%',
    },
  },
  section: {
    height: '100%',
  },
}));

export interface MyFilesProps extends ReactCookieProps {
  preview?: any;
}

const MyFiles: React.FC<MyFilesProps> = ({ preview, cookies }) => {
  const { classes } = useStyles();
  const { currentView, setCurrentView } = useContext(NavigationContext);
  const { title } = useContext(AppConstantsContext);
  const browserTitle = `Songbook - ${title}`;

  useEffect(() => {
    // check if we should set an affiliate cookie
    if (window && window.location && window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const affiliateCode = urlParams.get('affiliation');
      const existingCookie = cookies.get('affiliation');
      if (affiliateCode && (!existingCookie || existingCookie !== affiliateCode)) {
        const expiration = new Date();
        expiration.setDate(expiration.getDate() + 1);
        cookies.set(AFFILIATE_CODE_ID, affiliateCode, {
          path: '/',
          expires: expiration,
        });
      }
    }
  }, [cookies]);

  useEffect(() => {
    setCurrentView(View.songbook);
  }, [currentView, setCurrentView]);

  return (
    <>
      <Helmet>
        <title>{browserTitle}</title>
      </Helmet>

      <ComplianzCookieConsent />
      <div className={classes.app}>
        <section className={classes.section}>
          {/*
          <BlackFridayBanner />
           */}
          <ExportTranscriptionProvider>
            <ProcessingProvider>
              <Dashboard preview={preview} />
            </ProcessingProvider>
          </ExportTranscriptionProvider>
        </section>
      </div>
    </>
  );
};

export default withCookies(MyFiles);
